import { FormControlLabel, IconButton, OutlinedInput, Divider } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ColorPicker from '../../../../../../../../../reusable/ColorPicker/ColorPicker';
import { Clear } from '@material-ui/icons';
import { IconNames, getIconByName } from '../../../../../../../../../reusable/IconLibrary/IconLibrary';
import CardData from '../../../../../../../utils/CardData';
import { useCustomStyles } from "../../../../utils"
import TabBar from '../../../../../../../utils/TabBar';
import DropShadow from '../generalSettingsChild/DropShadow';
import { WidgetProps } from '../../../../../../widgetOverlay/widgetInteractionItem/WidgetProps';
import { getWidgetProps } from '../../../../../../../utils/helper';

type IconProps = {
	widgetTemplate:  WidgetProps.WidgetTemplate;
	isAtHoverSetting: boolean;
	setHoverSetting: (_value: boolean) => {};
	handleTextLabelColorChange: (_event: {} | undefined, _color: {}) => {};
	handleTextLabelHoverColorChange: (_event: {} | undefined, _color: {}) => {};
	onShowIconLibraryPickerModal: () => {};
	handleStylingAttributeChange: (_objKey: string | null, _attrKey: string, _value: any) => {};
};

const Icon = ({
	widgetTemplate: widgetTemplateProp,
	isAtHoverSetting,
	setHoverSetting,
	handleTextLabelColorChange,
	handleTextLabelHoverColorChange,
	onShowIconLibraryPickerModal,
	handleStylingAttributeChange
}: IconProps) => {
	const { t: translator } = useTranslation();
	const classes = useCustomStyles();

	const widgetTemplate = getWidgetProps(widgetTemplateProp) as WidgetProps.WidgetTemplate;
	const {
		style: {
			textLabel: { color, hoverColor }
		},
		settings: { iconKey } = { iconKey: '' },
	} = widgetTemplate;

	return (
		<CardData title={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_ICON')}>
			<div className="widget-props-wrapper">
				<div className="scene-widget__control">
					<TabBar
						size="big"
						items={[
							{
								label: translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_NORMAL'),
								id: 'normal',
								selected: !isAtHoverSetting,
							},
							{
								label: translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_HOVER'),
								id: 'hover',
								selected: isAtHoverSetting,
							},
						]}
						onItemClick={(_event: any, item: any) => setHoverSetting(item.id === 'hover')}
					/>
				</div>

				<div style={{ marginBottom: "8px" }}>{translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_ICON')}</div>
				<div className={'scene-widget__control'}>
					<div className="scene-widget__iconSelector--placeholder" onClick={onShowIconLibraryPickerModal}>
						<div className="scene-widget__iconSelector--icon">{getIconByName(iconKey as IconNames, {})}</div>
						<span>{iconKey}</span>
					</div>
					<button className='scene-widget__iconSelector--button' onClick={onShowIconLibraryPickerModal}>
						{translator('COMMON_CHANGE')}
					</button>
				</div>

				{!isAtHoverSetting && (<>
					<FormControlLabel
						className={'scenario-chart__control'}
						label={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_PRIMARY_COLOR')}
						onChange={handleTextLabelColorChange}
						labelPlacement="start"
						control={
							<div className="scene-widgets__sort-input-control">
								<OutlinedInput value={color} className={classes.input} />
								<ColorPicker
									width="28px"
									height="28px"
									padding="4px"
									color={color}
									onChangeComplete={(color: any) => handleTextLabelColorChange(undefined, color)}
								/>
								<IconButton size="small" onClick={() => handleTextLabelColorChange(undefined, { hex: '' })}>
									<Clear />
								</IconButton>
							</div>
						}
					/>
					<Divider className="divider-extra-space" />
					<DropShadow widgetTemplate={widgetTemplate as any} onDropShadowPropChange={(propKey: string, value: any) => handleStylingAttributeChange('transformSettings', propKey, value)} />
				</>)}

				{isAtHoverSetting && (<>
					<FormControlLabel
						className={'scenario-chart__control'}
						label={translator('SCENARIO_SCENE_EDITOR_WIDGET_SETTING_CONTENT_SETTING_HOVER_COLOR')}
						onChange={handleTextLabelHoverColorChange}
						labelPlacement="start"
						control={
							<div className="scene-widgets__sort-input-control">
								<OutlinedInput value={hoverColor ?? color} className={classes.input} />
								<ColorPicker
									width="28px"
									height="28px"
									padding="4px"
									color={hoverColor ?? color}
									onChangeComplete={(color: any) => handleTextLabelHoverColorChange(undefined, color)}
								/>
								<IconButton
									size="small"
									onClick={() => handleTextLabelHoverColorChange(undefined, { hex: '' })}
								>
									<Clear />
								</IconButton>
							</div>
						}
					/>
					<Divider className="divider-extra-space" />
					<DropShadow widgetTemplate={widgetTemplate as any} onDropShadowPropChange={(propKey: string, value: any) => handleStylingAttributeChange('transformSettings', propKey, value)} showHoverSetting={true} />
				</>)}
			</div>
		</CardData>
	);
};

export default Icon;
